import {BaseViewModel} from "../base-view-model";
import {observable} from "mobx";

export class PagingModel extends BaseViewModel {
  @observable nextPage: String = null;
  @observable previousPage: String = null;


  constructor(model: PagingModel) {
    super();

    this.nextPage = model.nextPage;
    this.previousPage = model.previousPage;
  }
}


